export default __webpack_public_path__ + "static/media/IMG_013.f9e58543.jpg";